import React from 'react'
import PropTypes from 'prop-types'
import { Link, graphql, StaticQuery } from 'gatsby'
import Img from "gatsby-image"

//import upload from '../img/upload-icon.svg'

import logo from '../img/logowhitev1.svg'
import facebook from '../img/social/facebook-logo.svg'
import linkedin from '../img/social/linkedin-logo.svg'
import google from '../img/social/google-logo.svg'

import instagram from '../img/social/instagram-logo.svg'
import youtube from '../img/social/youtube-logo.svg'

import FormSub from '../components/FormSub'


class Footer extends React.Component {
  componentDidMount(){
    // Handle FAQ show / hide on all  pages
    let faqs = document.querySelectorAll(".f-module")
    function showHide(i) {
     //console.log(faqs[i])
     //console.log(faqs[i].querySelector('.f-answer').style.display)

     if(faqs[i].querySelector('.f-answer').style.display !== 'none'){
        faqs[i].querySelector('.f-answer').style.display = 'none'
        faqs[i].querySelector('.f-arrow').style.transform = 'rotate(180deg)'
      }else {
        faqs[i].querySelector('.f-answer').style.display = 'block'
        faqs[i].querySelector('.f-arrow').style.transform = 'rotate(0deg)'
      }
    }



    if(faqs !== undefined){
    faqs.forEach((item, i) => {
     //console.log(i)
      if(i===0){
        faqs[i].querySelector('.f-answer').style.display = 'block'
      } else {
        faqs[i].querySelector('.f-answer').style.display = 'none'
      }
      item.addEventListener(
          'click',
           function(){
            //console.log([i]);
              showHide(i);
           }
         );
    });

  }}
  render() {
    const { data } = this.props
    //console.log(data)
    const { edges: posts } = data.posts
    const { edges: offers } = data.offers

    return (
      <footer className="footer has-background-black has-text-white-ter">
        <div className="content has-text-centered">
          <Link to="/"><img
            loading="lazy"
            src={logo}
            alt="e-multicontent - copywriting, tłumaczenia, seo, strony internetowe, e-commerce, marketplace"
            style={{ width: '14em', height: '10em',animation:'ollie 30s infinite' }}
          /></Link>
        </div>
        <div className="content has-text-centered has-background-black has-text-white-ter">
          <div className="container has-background-black has-text-white-ter">
            <div className="columns">
            <div className="column" style={{maxWidth:'15%'}} id="fcol">
              <section>
                <ul className="menu-list">
                <li>
                  <Link to="/" className="navbar-item">
                    Home
                  </Link>
                </li>

                <li>
                  <Link className="navbar-item" to="/oferta/">
                    Oferta
                  </Link>
                </li>

                <li>
                  <Link className="navbar-item" to="/o-nas/">
                    O nas
                  </Link>
                </li>

                  <li>
                    <Link className="navbar-item" to="/blog/">
                      Blog
                    </Link>
                  </li>

                  <li>
                    <Link className="navbar-item" to="/portfolio/">
                      Portfolio
                    </Link>
                  </li>

                  <li>
                    <Link className="navbar-item" to="/kontakt/">
                      Kontakt
                    </Link>
                  </li>

                  <li>
                    <Link className="navbar-item" to="/kariera/">
                      Kariera
                    </Link>
                  </li>

                  <li>
                    <Link className="navbar-item" to="/ebook/">
                      Ebook
                    </Link>
                  </li>

                  <li>
                    <Link className="navbar-item" to="/partnerzy/">
                      Partnerzy
                    </Link>
                  </li>

                  {/*<li>
                    <Link className="navbar-item"  to="/akademia-beomni-e-commerce/">
                    Akademia <br /> BEOMNI
                  </Link>
                  </li>*/}

                  <li>
                  <a
                    className="navbar-item"
                    href="https://docs.google.com/forms/d/e/1FAIpQLSdANuJU_Y9eE5CYJcBx6JIwMOj6i4KxKQ7lHydKXE89vRfVMQ/viewform"
                    target="_blank"
                    rel="noopener noreferrer"
                  >Brief</a>
                  </li>
                  <li>
                  <a
                    className="navbar-item"
                    href="https://en.e-multicontent.pl"
                    rel="noopener noreferrer"
                  ><Img fixed={data.file.childImageSharp.fixed} alt="english" aria-label="english" />&nbsp;&nbsp; EN</a>
                  </li>

                </ul>
              </section>
            </div>
              <div className="column">
                  <ul className="menu-list" style={{fontSize:'13.4px'}}>
                    {offers &&
                      offers
                      .map(({ node: post }) => (
                      <li key={post.id}>  <Link className='navbar-item'  to={post.fields.slug} >
                          {post.frontmatter.title}
                        </Link></li>
                    ))}
                  </ul>

              </div>

              <div className='column'>
              <ul style={{textAlign:'left',fontSize:'12px'}}>
                {posts &&
                  posts.slice(0,10)
                  .map(({ node: post }) => (
                  <li key={post.id}>  <Link className='navbar-item'  to={post.fields.slug} >
                      {post.frontmatter.title}
                    </Link></li>
                ))}
              </ul>

              </div>


              <div id="newsletter" className="column social">





                <br />
                <p style={{color:'white', fontSize:'12px', textAlign: 'center'}}>


            <a className="dedlink" style={{lineHeight:'2',padding:'7px',marginBottom:'20px',borderRadius:'5px'}} href="mailto:biuro@e-multicontent.pl" target="_blank" rel="noopener noreferrer">  <b>biuro@e-multicontent.pl</b> </a>
                <br />
                <br />
            <a className="dedlink" style={{lineHeight:'2',padding:'7px',borderRadius:'5px'}} href="tel:+48713074517" target="_blank" rel="noopener noreferrer">     <b>+48 71 307 45 17</b> </a>
                <br />
                <br />
                pn. – pt.
                <br />
              <b>8:00 – 16:00</b>
              <br />
              <br />
            <i>  Katarzyńska 1 F,<br /> 55-010 Radwanice</i>
            <br />
            <br />
            Jesteś zadowolony?
            <br />
            <br />
            <a className="btn" style={{lineHeight:'2',padding:'7px',marginBottom:'20px'}} target="_blank"  rel="noopener noreferrer" href="https://g.page/r/Ca2eI1CTOqnGEAI/review"> <b> Zostaw nam opinię! </b> </a>
            </p>

                <br />
                  <a className="icon" title="facebook" target="_blank"  rel="noopener noreferrer" href="https://www.facebook.com/emulticontent.ecommerce">
                    <img
                      loading="lazy"
                      src={facebook}
                      alt="Facebook"
                      style={{ width: '1em', height: '1em' }}
                    />
                  </a>
                  <a className="icon" title="instagram" target="_blank"  rel="noopener noreferrer" href="https://www.instagram.com/emulticontent">
                    <img
                      loading="lazy"
                      src={instagram}
                      alt="instagram"
                      style={{ width: '1em', height: '1em' }}
                    />
                  </a>
                  <a className="icon" title="linkedin" target="_blank"  rel="noopener noreferrer" href="https://www.linkedin.com/showcase/multicontent/about/?viewAsMember=true">
                    <img
                      loading="lazy"
                      src={linkedin}
                      alt="Linkedin"
                      style={{ width: '1em', height: '1em' }}
                    />
                  </a>
                  <a className="icon" title="youtube" target="_blank"  rel="noopener noreferrer" href="https://www.youtube.com/@e-multicontent_ecommerce">
                    <img
                      loading="lazy"
                      src={youtube}
                      alt="YouTube"
                      style={{ width: '1em', height: '1em' }}
                    />
                  </a>
                  <a className="icon" title="google" target="_blank"  rel="noopener noreferrer" href="https://g.page/e-multicontent/">
                    <img
                      loading="lazy"
                      src={google}
                      alt="google"
                      style={{ width: '1em', height: '1em' }}
                    />
                  </a>

              </div>


              <div className="column">




              <div>


              <br />
              <FormSub/>
                {/*newsletter
                  <iframe id="fm-fc-f-icbflj0rmx" src="https://forms.freshmail.io/f/70jqexgyfc/icbflj0rmx/index.html" title="newsletter" frameBorder="0" marginHeight="0" marginWidth="0" width="100%" style={{minHeight: '390px'}}></iframe>
                  */}
              <br />
              </div>


              <br />



              </div>

            </div>
            <br />
              <div className="content has-text-centered has-background-black">

                  <p style={{ paddingBottom: '10px', color: '#36b3d2', fontSize: '12px'}}>
                  <a
                      href="/polityka-prywatnosci/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Polityka prywatności
                    </a> | <a
                        href="/polityka-prywatnosci/#cookies"
                        target="_blank"
                        rel="noopener noreferrer"
                      >Polityka plików cookies</a> | <a
                          href="/sitemap.xml"
                          target="_blank"
                          rel="noopener noreferrer"
                        >Mapa strony</a> </p>


                    <p style={{ paddingBottom: '10px', color: 'white', fontSize: '10px'}}><Link to="/" style={{color:'white'}}><b>e-multicontent.pl®</b> {new Date().getFullYear()}</Link> |   jest częścią <b><a style={{color:'#36b3d2'}} rel="noopener noreferrer" target="_blank" href='https://iv-group.pl'> INNOVISION GROUP</a></b> </p>
                    <br />
                </div>
          </div>

        </div>

      </footer>
    )
  }
}



Footer.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
}

export default () => (
  <StaticQuery
    query={graphql`
      query footerQuery {
        file(relativePath: {regex: "/optimized/english.png/"}) {
          childImageSharp {
            fixed(width: 20, height: 20) {
              ...GatsbyImageSharpFixed_withWebp_noBase64
              srcWebp
            }
          }
        }
        posts : allMarkdownRemark(
          limit: 10,
          sort: { order: DESC, fields: [frontmatter___date] }
          filter: { frontmatter: { templateKey: { eq: "blog-post" } } }
        ) {
          edges {
            node {
              id
              fields {
                slug
              }
              frontmatter {
                title
                templateKey
              }
            }
          }
        }
        offers : allMarkdownRemark(
          sort: { order: DESC, fields: [frontmatter___date] }
          filter: { frontmatter: { templateKey: { eq: "offer-page" } } }
        ) {
          edges {
            node {
              id
              fields {
                slug
              }
              frontmatter {
                title
                templateKey
              }
            }
          }
        }
      }
    `}
    render={(data, count) => <Footer data={data} count={count} />}
  />
)
